import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {VendorDataService} from "../../vendor/vendor.data.service";
import {VendorService} from "../../vendor/vendor.service";
import {ToasterService} from "../../../../services/core/toaster.service";
import {SharedService} from "../../../shared/shared.service";
import {HtmlService} from "../../../../services/core/html.service";
import {NgDialogAnimationService} from 'src/app/services/core/ng-dialog-animation.service';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {first} from "rxjs/operators";
import {WarehouseDataService} from "../warehouse.data.service";
import {WarehouseService} from "../warehouse.service";
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";
import {WarehouseNameComponent} from "../form-part/warehouse-name/warehouse-name.component";
import {WarehouseAddressDetailComponent} from "../form-part/warehouse-address-detail/warehouse-address-detail.component";
import {MatStepper} from "@angular/material/stepper";
import {Router} from "@angular/router";
import {DialogService} from "../../../../services/core/dialog.service";
import {ModuleDataMilestoneService} from "../../../../services/module-data-milestone.service";

@Component({
    selector: 'app-warehouse-create',
    templateUrl: './warehouse-create.component.html',
    styleUrls: ['./warehouse-create.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
    ],
    standalone: false
})
export class WarehouseCreateComponent implements OnInit {
  // @ts-ignore
  @ViewChild(WarehouseNameComponent,{static: true}) warehouseNameComponent: WarehouseNameComponent;// @ts-ignore
  @ViewChild(WarehouseAddressDetailComponent,{static: true}) warehouseAddressDetailComponent: WarehouseAddressDetailComponent;
  @Output() callback = new EventEmitter<any>(true);
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  public submitted = false;
  /** True while the create/update request is in flight — drives the button
   *  loading state so the operator knows the warehouse is being saved. */
  public isSubmitting = false;
  public model:any ={};
  public customerTypes:any;
  public warehouseForm!: UntypedFormGroup;
  public step:any;
  public finalPreview = false;
  public id: string = '';

  /** Module id of the Warehouse module — used for milestone auto-deploy. */
  private readonly WAREHOUSE_MODULE_ID = 17;

  constructor(
    public fb: UntypedFormBuilder,
    public toasterService: ToasterService,
    public sharedService: SharedService,
    private htmlService: HtmlService,
    private router: Router,
    public warehouseDataService: WarehouseDataService,
    public warehouseService: WarehouseService,
    public dialog: NgDialogAnimationService,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WarehouseCreateComponent>,
    public dialogService: DialogService,
    private moduleDataMilestoneService: ModuleDataMilestoneService,
  ) {
    this.model = this.data;
    this.id = this.data?.id;
  }


  ngOnInit(): void {
    // this.htmlService.setTitle('Warehouses');
    this.initWarehouseForm();
  }
  initWarehouseForm(){
    this.warehouseForm = new UntypedFormGroup({
      step01: new UntypedFormGroup({
        wareHouse: new UntypedFormControl(null),
      }),
      step02: new UntypedFormGroup({
        wareHouseDetail: new UntypedFormControl(null),
      }),
    });
  }
  initChildForm(step: string, formControlName: string, value:any){
    this.warehouseForm.get(step)?.get(formControlName)?.setValue(value);

  }
  onStepChanged = (event:any, stepper:any) => {
    this.step = {event:event, stepper:stepper};

  }
  touchFormControls(formControlName: string, secondFormControlName: any = null){
    let warehouseForm = this.warehouseForm.get(formControlName);
    // @ts-ignore
    warehouseForm = secondFormControlName ? warehouseForm?.get(secondFormControlName) : warehouseForm;
    warehouseForm?.markAsTouched()
    warehouseForm?.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }

  onSubmit() {
    if (this.warehouseForm.invalid) {
      this.toasterService.showWarning('Please fill all required field.');
      return;
    }
    if (this.isSubmitting) {
      return; // guard against double-submit while a request is in flight
    }
    this.isSubmitting = true;
    const isCreate = !this.id;
    const  warehouseDataService = this.id ?
      this.warehouseDataService.update(this.model.id , this.getFormData()) :
      this.warehouseDataService.create(this.getFormData());

    warehouseDataService
      .pipe(first())
      .subscribe({
        next: data => {
          this.callback.emit(data);
          this.warehouseForm.reset();
          if (isCreate) {
            const newWarehouseId = data?.data?.data?.id;
            if (newWarehouseId) {
              this.autoDeployMilestones(newWarehouseId);
            }
          }
          this.isSubmitting = false;
          this.close(data);
          this.toasterService.showSuccessMessage(data?.data.message);
        },
        error: () => {
          // The data service surfaces the error toast; just re-enable the
          // button so the operator can retry.
          this.isSubmitting = false;
          this.cd.markForCheck();
        }
      });
  }

  /**
   * After a warehouse is created, attach the Warehouse module's auto-deploy milestone
   * template (if one is enabled). Fire-and-forget — failures are logged silently and
   * never block the create flow.
   */
  private autoDeployMilestones(warehouseId: number) {
    this.moduleDataMilestoneService
      .autoDeploy(this.WAREHOUSE_MODULE_ID, warehouseId)
      .pipe(first())
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Milestone auto-deploy failed for warehouse', warehouseId, err);
        }
      });
  }
  getFormData = () => {
    const formValue = this.warehouseForm.value;
    const payload = {
      name: formValue.step01.wareHouse.name,
      email: formValue.step01.wareHouse.email,
      phone: formValue.step01.wareHouse.phone,
      fax: formValue.step01.wareHouse.fax,
      address_line_1: formValue.step02.wareHouseDetail.main_address.address_line_1,
      address_line_2: formValue.step02.wareHouseDetail.main_address.address_line_2,
      city: formValue.step02.wareHouseDetail.main_address.city,
      state_id: formValue.step02.wareHouseDetail.main_address.state_id.id,
      zipcode: formValue.step02.wareHouseDetail.main_address.zipcode,
    };

    return payload;
    
  }
  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  close = (data:any) => {
    //this.dialogRef.close(data);
    this.dialogService.onClose(data);
  }

  finalPreviewFn(stepper: MatStepper){
    this.touchFormControls('step02','wareHouseDetail');
    // @ts-ignore
    const isInvalid =this.warehouseForm.get('step02').get('wareHouseDetail').invalid;
    console.log('isInvalid' , isInvalid);
    // @ts-ignore
    console.log('this.warehouseForm.get(\'step02\')?.invalid' , this.warehouseForm.get('step02').get('wareHouseDetail'));
    if (!isInvalid){
      stepper.next();
    }

  }
  cancelPreview(){
    this.finalPreview = false;
    this.step.event.selectedIndex = 2;
  }

  checkFormValidity(formName: any){
   return this.warehouseForm.get(formName)?.invalid;
 }
}
